import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { InactiveRecordsIcon } from '@/assets/icons/InactiveRecordsIcon';
import { EntityType } from '@/core/graphql/generated/types';
import { Permission } from '@/core/store/auth/auth.types';
import { useHasPermission } from '@/core/store/auth/authSelectors';
import { useOpenDcrModal } from '@/core/store/dcrModal/dcrModalSelectors';
import { useQueryParams } from '@/utils/url/useQueryParams';

import { inactiveOptInNudgeStyles as sx } from './InactiveOptInNudge.styles';

type Props = {
	count: number;
	entityType: EntityType;
};

export const InactiveOptInNudge = ({ count, entityType }: Props) => {
	const { t } = useTranslation();
	const { setQueryParams } = useQueryParams();
	const dcrEnabled = useHasPermission(Permission.DcrEnabled);
	const openDcrModal = useOpenDcrModal();

	const handleInclude = () => {
		setQueryParams({ includeInactive: true, page: undefined });
	};

	return (
		<Box sx={sx.root}>
			<InactiveRecordsIcon sx={sx.icon} />

			<Box sx={sx.body}>
				<Typography sx={sx.header}>
					{t('{{count, isNumber}} inactive records also match this search', {
						count
					})}
				</Typography>
				<Button
					sx={sx.button}
					variant='outlined'
					onClick={handleInclude}
					size='small'
				>
					{t('Include Inactive')}
				</Button>
				{dcrEnabled && (
					<Link
						component='button'
						type='button'
						sx={sx.requestLink}
						onClick={() => openDcrModal(entityType)}
					>
						{entityType === EntityType.Hcp
							? t('Request a new HCP')
							: t('Request a new HCO')}
					</Link>
				)}
			</Box>
		</Box>
	);
};
